export default __webpack_public_path__ + "static/media/messages.8fad9e66.png";